import { Route } from "@angular/router";
import { MODULE_RESOURCES, moduleAccess } from "@core/config/module-access";
import { Page404Component } from "app/authentication/page404/page404.component";
import { CompaniesRecordsComponent } from "./companies-records/companies-records.component";
import { CompaniesRecordDetailComponent } from "./companies-records/companies-record-detail.component";
import { OrgUnitsComponent } from "./org-units/org-units.component";
import { EmployeesComponent } from "./employees/employees.component";
import { EmployeeDetailComponent } from "./employees/employee-detail.component";
import { employeeUnsavedChangesGuard } from "./employees/employee-unsaved-changes.guard";


export const CLIENT_ROUTE: Route[] = [
    {
        path: "companiesRecords",
        redirectTo: "companies-records",
        pathMatch: "full",
    },
    {
        path: "companies-records/new",
        component: CompaniesRecordDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.companiesRecords),
        },
    },
    {
        path: "companies-records/:companiesRecordId/edit",
        component: CompaniesRecordDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.companiesRecords),
        },
    },
    {
        path: "companies-records/:companiesRecordId",
        component: CompaniesRecordDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.companiesRecords),
        },
    },
    {
        path: "companies-records",
        component: CompaniesRecordsComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ORGANIZATION.LIST.COMPANIESRECORDS',
                order: 2,
            },
            auth: moduleAccess(MODULE_RESOURCES.client.organization.companiesRecords),
        },
    },
    {
        path: "org-units",
        component: OrgUnitsComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ORGANIZATION.LIST.ORGUNITS',
                order: 2,
            },
            auth: moduleAccess(MODULE_RESOURCES.client.organization.orgUnits),
        },
    },
    {
        path: "employees/new",
        component: EmployeeDetailComponent,
        canDeactivate: [employeeUnsavedChangesGuard],
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.employees),
        },
    },
    {
        path: "employees/:employeeId/edit",
        component: EmployeeDetailComponent,
        canDeactivate: [employeeUnsavedChangesGuard],
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.employees),
        },
    },
    {
        path: "employees/:employeeId",
        component: EmployeeDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.client.organization.employees),
        },
    },
    {
        path: "employees",
        component: EmployeesComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ORGANIZATION.LIST.EMPLOYEES',
                order: 3,
            },
            auth: moduleAccess(MODULE_RESOURCES.client.organization.employees),
        },
    },

    { path: "**", component: Page404Component },
];
